import { DateText } from '@stories/Components/DateText/DateText.tsx'

export interface DateTextProps {
  dates: string[] | null
}

export const CampItemDates = ({ dates }: DateTextProps) => {
  if (!dates || dates.length === 0) {
    return null
  }

  return (
    <span data-testid="dates-label">
      <DateText date={dates[0]} />
      {dates.length > 1 && (
        <>
          <span> - </span>
          <DateText date={dates[dates.length - 1]} />
        </>
      )}
    </span>
  )
}
